import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// macOS-style auto-hide overlay scrollbars on non-Safari browsers.
// Safari already provides a native overlay scrollbar, so leave it alone.
// The .is-scrolling marker is scoped to whichever element is actually
// scrolling, not the whole page, so only that scrollbar appears.
(() => {
  const ua = navigator.userAgent;
  const isSafari =
    /Safari/i.test(ua) &&
    !/Chrome|Chromium|Edg|OPR|Firefox|FxiOS|CriOS/i.test(ua);
  if (isSafari) return;

  document.documentElement.classList.add('custom-scrollbars');

  const timers = new WeakMap();
  const HIDE_DELAY_MS = 700;

  document.addEventListener(
    'scroll',
    (e) => {
      // window/document scroll targets `document`; its scrollbar lives on <html>.
      const el =
        e.target === document ? document.scrollingElement : e.target;
      if (!el || !el.classList) return;

      el.classList.add('is-scrolling');
      clearTimeout(timers.get(el));
      timers.set(
        el,
        setTimeout(() => {
          el.classList.remove('is-scrolling');
          timers.delete(el);
        }, HIDE_DELAY_MS),
      );
    },
    { capture: true, passive: true },
  );
})();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
